import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ScenariosSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="bg-sand py-20 lg:py-28" ref={ref} data-id="element-474" data-mp="176wxj91jl48y">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-475" data-mp="1c82rfa6xuxk2">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.55,
        ease: EASE
      }} className="esca-h2 text-ink max-w-[20ch] text-balance" data-id="element-476" data-mp="1c5gltg3lys4h">
          {c.scenarios.title}
        </motion.h2>

        <div className="mt-14 lg:mt-20 border-t border-line" data-id="element-477" data-mp="2sjq69z4qbwq1">
          {c.scenarios.items.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 14
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.08 + i * 0.06,
          ease: EASE
        }} className="group border-b border-line" data-id="element-478" data-mp="2xijjrrk0nnq7" data-mpi={i}>
              <div className="grid grid-cols-[auto_1fr] lg:grid-cols-[6rem_minmax(0,22rem)_1fr] gap-x-6 lg:gap-x-10 gap-y-3 py-8 lg:py-10 transition-colors duration-200 group-hover:bg-white px-0 lg:px-6 lg:-mx-6" data-id="element-479" data-mp="rqhsy4q99jyv">
                <span className="font-display text-lg lg:text-xl font-semibold tabular-nums text-muted transition-colors duration-200 group-hover:text-accent" data-id="element-480" data-mp="mp731nhrqo">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="font-display text-xl lg:text-[1.75rem] font-semibold text-ink tracking-[-0.02em] leading-tight" data-id="element-481" data-mp="1pcynx3binlhg">
                  {item.title}
                </h3>
                <p className="col-start-2 lg:col-start-3 text-[1.0625rem] text-muted leading-relaxed max-w-[50ch]" data-id="element-482" data-mp="1sf34r4laddko">
                  {item.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}